import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Hooper, Slide, Pagination as HooperPagination } from 'hooper';
import SegmentAnalyticsMixin from '../helpers/vue_mixins/v2/SegmentAnalyticsMixin';
import TheFooter from '../components/Footer.vue';
import GetStarted from '../components/GetStarted.vue';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
import UserAgentMixin from '../helpers/mixins/UserAgentMixin';
import 'hooper/dist/hooper.css';
let GCashIntegration = class GCashIntegration extends Mixins(ViewportSizeMixin, SegmentAnalyticsMixin, UserAgentMixin) {
    get videoDimensions() {
        if (this.smAndDown) {
            return { width: 320, height: 250 };
        }
        return { width: 820, height: 520 };
    }
    goToBlog() {
        window.open('https://blog.chatgenie.ph/orders-coming-from-your-mini-app-can-now-be-delivered-by-grab-express/');
    }
    goToLandingPage() {
        window.open('https://chatgenie.ph');
    }
    get gcashCmsActivation() {
        return {
            src: require('@/assets/images/gcash-activation-instruction.png'),
            height: this.smAndDown ? '100' : '305',
        };
    }
    get heroBanners() {
        return [
            require('@/assets/images/gcash-banner1.png'),
            require('@/assets/images/gcash-banner3.png'),
            require('@/assets/images/gcash-banner2.png'),
            require('@/assets/images/gcash-banner4.png'),
        ];
    }
    get howItWorksBanners() {
        return [
            require('@/assets/images/gcash-how-it-works-1.png'),
            require('@/assets/images/gcash-how-it-works-2.png'),
            require('@/assets/images/gcash-how-it-works-3.png'),
            require('@/assets/images/gcash-how-it-works-4.png'),
            require('@/assets/images/gcash-how-it-works-5.png'),
            require('@/assets/images/gcash-how-it-works-6.png'),
        ];
    }
    get howItWorksSections() {
        return [
            {
                description: `As a Merchant, you’ll receive real-time email notifications when a payment is received via GCash.
                      Apart from email notifications, the payment status on every pending order entry on your Order
                      Manager will be updated in real-time.`,
                img: require('@/assets/images/gcash-benefit-1.png'),
            },
            {
                description: `In case that the customer accidentally closed the GCash Web payment page, they can always go back
                      to the Order History Page to continue with the payment.`,
                img: require('@/assets/images/gcash-benefit-2.png'),
            },
        ];
    }
};
GCashIntegration = __decorate([
    Component({
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.$store.state.displayHomeNav = true;
                return true;
            });
        },
        components: {
            Hooper,
            Slide,
            HooperPagination,
            TheFooter,
            GetStarted,
        },
    })
], GCashIntegration);
export default GCashIntegration;
